import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { TherapiesQuestionnaireItem } from './questionnaire'

export const THERAPIES_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [TherapiesQuestionnaireItem.MEDICAL_BACKGROUND_THERAPIES_THERAPIES]:
    QuestionnaireAnswerType.STRING,
  [TherapiesQuestionnaireItem.MEDICAL_BACKGROUND_THERAPIES_THERAPY_PROVIDER]:
    QuestionnaireAnswerType.STRING,
  [TherapiesQuestionnaireItem.MEDICAL_BACKGROUND_THERAPIES_HOME_EXERCISE_PLAN]:
    QuestionnaireAnswerType.STRING,
  [TherapiesQuestionnaireItem.MEDICAL_BACKGROUND_THERAPIES_HOME_EXERCISE_DURATION]:
    QuestionnaireAnswerType.STRING,
  [TherapiesQuestionnaireItem.MEDICAL_BACKGROUND_THERAPIES_HOME_EXERCISE_FREQUENCY]:
    QuestionnaireAnswerType.INTEGER
}
